import { FC, memo } from 'react'

import { Text, Button } from '@cash-me/react-components'
import NextImage from "next/image"

import { Infos, Section } from 'components/general-styles/General'
import { Grid, Col } from 'components/grid'
import useWindowSize from 'hooks/useWindowSize'

import { BoostsPlansProps } from './boosts-plans.model'
import * as S from './styles'

const BoostsPlans: FC<BoostsPlansProps> = memo(({ onClick }) => {
  const { isDesktop } = useWindowSize()

  return (
    <Section>
      <Grid col={{ phone: 1, tablet: 2, desktop: 12 }}>
        <Col col={{ desktop: 5 }} start={{ desktop: 2 }}>
          <S.ImageWrapper>
            <NextImage
              src={`${process.env.NEXT_PUBLIC_SITE_IMAGES_PREFIX}/images/site/online-loan/man-smiling.png?updated=230602`}
              alt="Homem sorrindo"
              width="536"
              height="691"
              sizes="100vw"
              style={{
                width: "100%",
                height: "auto"
              }} />
          </S.ImageWrapper>
        </Col>
        <Col col={{ desktop: 5 }}>
          <Infos>
            <Text className="subtitle" size="caption" weight="medium" uppercase>
              A CashMe é para você
            </Text>
            <Text as="h2" size="heading3" weight="medium">
              Por que {' '}
              <Text as="span" size="heading3" weight="medium" color="var(--colors-pink-text-default)">
                escolher a CashMe?
              </Text>
            </Text>
            <Text color="var(--colors-neutral-text-weak)">
              Nascemos com o objetivo de trazer agilidade e custos atraentes a quem busca crédito com os 
              juros reduzidos. 
            </Text>
            <Text color="var(--colors-neutral-text-weak)">
              Oferecemos empréstimo com garantia de imóvel porque acreditamos que essa é a modalidade de 
              financiamento mais eficaz, segura, barata e rápida do mercado. 
            </Text>
            <Text color="var(--colors-neutral-text-weak)">
              Com a CashMe, você nem precisa sair de casa para dar crédito aos seus sonhos! Pois, nosso 
              serviço é 100% digital. Para a sua tranquilidade, protegemos seus dados a partir de 
              protocolos e tecnologias que garantem a segurança das suas informações e da sua empresa.
            </Text>
            <Text color="var(--colors-neutral-text-weak)">
              Impulsionamos você às suas conquistas de um jeito descomplicado. Em uma relação cuidadosa, 
              para você transformar a sua vida financeira ou a do seu negócio. Tudo isso, com uma base 
              sólida em tecnologia, inovação e transparência. 
            </Text>
            <Text color="var(--colors-neutral-text-weak)">
              Porque crescendo juntos a gente vai mais longe!
            </Text>
            <Button
              size="lg"
              onClick={onClick}
              {...(isDesktop ? { variants: 'default', iconName: 'arrowRight' } : { variants: 'text-only' })}
            >
              Simular agora
            </Button>
          </Infos>
        </Col>
      </Grid>
    </Section>
  );
})

BoostsPlans.displayName = 'BoostsPlans'

export default BoostsPlans
